import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TaskService } from '@app/_components/task';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TagService } from '../task/tag';

@Component({
    selector: 'app-tag-search',
    template: `
  <span style='font-size: 80%; float:right;'><a [routerLink]="" (click)="removeAllTags()">Clear All</a></span>
  <p-autoComplete
      [(ngModel)]="taskTagList"
  	  [suggestions]="tagSuggestions"
      [multiple]="true"
      [forceSelection]="false"
      [dropdown]="false"
      [style]="{'width':'100%','padding-bottom':'20px'}"
      [inputStyle]="{'width':'100%'}"
      [minLength]="1"
      unique="true"
      field="name"
      placeholder="Tags"
      (onSelect)="onSelect($event)"
      (onUnselect)="onUnselect($event)"
      (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
  `,
    styles: [],
    standalone: false
})
export class TagSearchComponent implements OnInit, OnChanges {
	tagSuggestions: string[];

	tagSelectForm: UntypedFormGroup;

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() addFilterTag = new EventEmitter<string>();

	@Output() deleteFilterTag = new EventEmitter<string>();

	@Input() tags;

	@Input() tagType: number;

	taskTagList: any;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private taskService: TaskService,
		private tagService: TagService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit() {
		this.tagSelectForm = this.formBuilder.group({
			taskTag: [this.tags],
		});
	}

	// for each letter typed in autocomplete...
	onKeyInput(event) {
		let query = event.query;
		this.findTagsWith(query);
		return this.tagSuggestions;
	}


	onSelect(event) {
		console.log('onSelect: ' + JSON.stringify(event));
		console.log('onSelect: ' + JSON.stringify(this.taskTagList));
		this.addFilterTag.emit(event);
	}


	onUnselect(event) {
		console.log('onSelect: ' + JSON.stringify(event));
		this.deleteFilterTag.emit(event);
	}

	removeAllTags() {
		this.taskTagList = [];
	}

	// used for auto-complete
	findTagsWith(queryString: string) { 
		this.reportService.findTagsWith(queryString, null).pipe(first()).subscribe(

			data => {
				// console.log('tags are: ' + JSON.stringify(data));
				this.tagSuggestions = [];
				this.tagSuggestions = data.data.tagSummaryList;
				// console.log('QA: ' + JSON.stringify(this.tagSuggestions));
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	// used to populate all tags for local autoComplete with dropdown
	findAllTags() {
		this.tagService.findAll().pipe(first()).subscribe(

			data => {
				// console.log('tags are: ' + JSON.stringify(data));
				this.alertService.success(data, true);
			},
			error => {
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() => { }
		);
	}

	ngOnChanges() {
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.tagSelectForm !== undefined) {
		}
	}
}
